import React, { Component } from 'react';
import { Tabs, Card, Form, Input, Button, Select } from 'antd';
import { withRouter } from 'react-router-dom';
import { changePassword, getMyBranches, setCurrentBranch } from '../services/api';
import { connect } from 'react-redux'
import { isEmptyObj } from '../utils';
import { load_profile } from '../redux/actions/profile';

const { Option } = Select;
const { TabPane } = Tabs;

class Profile extends Component {

    constructor(props) {
        super(props);
        this.state = {
            confirmPasswordValidateStatus: undefined,
            confirmPasswordValidateMessage: undefined,
            myBranches: [],
            currentBranchId: null
        }
        this.onPasswordDataChanged = this.onPasswordDataChanged.bind(this)
        this.onProfileDataChanged = this.onProfileDataChanged.bind(this)
        this.onChangePasswordSubmit = this.onChangePasswordSubmit.bind(this)
        this.setCurrentBranchId = this.setCurrentBranchId.bind(this)
        this.saveCurrentBranch = this.saveCurrentBranch.bind(this)
        this.onTabChange = this.onTabChange.bind(this)
        this.getMyBranchData = this.getMyBranchData.bind(this)
    }

    onPasswordDataChanged(key, value) {
        this.setState({
            [key]: value
        })
    }

    onProfileDataChanged(changed, all) {
        if (changed['confirm_new_password'] !== undefined) {
            if (changed['confirm_new_password'] !== all['new_password']) {
                this.setState({
                    confirmPasswordValidateStatus: "error",
                    confirmPasswordValidateMessage: "รหัสผ่านใหม่ไม่เหมือนกับช่องด้านบน"
                })
            }
            else {
                this.setState({
                    confirmPasswordValidateStatus: "success",
                    confirmPasswordValidateMessage: undefined
                })
            }

        }
    }

    async onChangePasswordSubmit(values) {
        await changePassword(values.old_password, values.new_password)
    };

    async getMyBranchData() {
        const { profile } = this.props
        if (!isEmptyObj(profile)) {
            let currentBranchId = undefined
            if (profile.profile.current_branch !== null){
                currentBranchId = profile.profile.current_branch.id
            }
            const res = await getMyBranches()
            const myBranches = res.data.user_branches.map(ub => ub.branch)
            this.setState({
                myBranches,
                currentBranchId
            })
        }
    }

    async setCurrentBranchId(value) {
        this.setState({
            currentBranchId: value
        })
    }

    async saveCurrentBranch() {
        const { history, dispatch } = this.props
        const { currentBranchId } = this.state
        await setCurrentBranch(currentBranchId)
        // Get new profile
        await dispatch(load_profile())
        history.push('/routes')
    }

    onTabChange(tabNum){
        if(tabNum === "2"){
            this.getMyBranchData()
        } 
    }

    render() {
        const { confirmPasswordValidateStatus, confirmPasswordValidateMessage, myBranches, currentBranchId } = this.state

        return (

            <Card className="no-pad-left" style={{ maxWidth: 600, margin: 'auto', overflowX: 'scroll' }}>
                <Tabs tabPosition={'top'} onChange={e => this.onTabChange(e)}>
                    <TabPane tab="รหัสผ่าน" key="1">
                        <h2>เปลี่ยนรหัสผ่าน</h2>
                        <Form
                            layout={'vertical'}
                            onValuesChange={this.onProfileDataChanged}
                            onFinish={this.onChangePasswordSubmit}
                        >
                            <Form.Item label="รหัสผ่านเดิม" name="old_password" hasFeedback rules={[{ required: true, message: 'กรุณาใส่รหัสผ่านเดิม' }]}>
                                <Input type="password" />
                            </Form.Item>
                            <Form.Item label="รหัสผ่านใหม่" name="new_password" hasFeedback rules={[{ required: true, message: 'กรุณาใส่รหัสผ่านใหม่' }, { min: 8, message: 'ความยาวรหัสผ่านต้องมีจำนวน 8-12 ตัวอักษร' }, { max: 12, message: 'ความยาวรหัสผ่านต้องมีจำนวน 8-12 ตัวอักษร' }]}>
                                <Input type="password" />
                            </Form.Item>
                            <Form.Item label="ยืนยันรหัสผ่านใหม่" name="confirm_new_password" hasFeedback help={confirmPasswordValidateMessage} validateStatus={confirmPasswordValidateStatus}>
                                <Input type="password" />
                            </Form.Item>
                            <Form.Item>
                                <Button type="primary" htmlType="submit">บันทึก</Button>
                            </Form.Item>
                        </Form>
                    </TabPane>
                    <TabPane tab="สาขาที่ใช้งาน" key="2">
                        <h2>สาขาที่ใช้งาน</h2>
                        <Form>
                            <Form.Item>
                                <Select
                                    value={currentBranchId}
                                    style={{ width: '100%' }}
                                    placeholder="กรุณาเลือกสาขา"
                                    optionFilterProp="children"
                                    onSelect={e => this.setCurrentBranchId(e)}
                                >
                                    {myBranches.map(mb =>
                                        <Option key={mb.id} value={mb.id}>{mb.code} {mb.name}</Option>
                                    )}
                                </Select>
                            </Form.Item>
                            <Form.Item>
                                <Button type="primary" onClick={this.saveCurrentBranch}>บันทึก</Button>
                            </Form.Item>
                        </Form>
                    </TabPane>
                </Tabs>
            </Card>

        );
    }
}

function mapStateToProps(state) {
    return {
        profile: state.profile
    };
}

export default withRouter(connect(mapStateToProps)(Profile));